import React, { useEffect, useRef, useState } from "react";
import MainHeading from "../../../components/comman/MainHeading";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import EditIcon from "../../../components/Icons/EditIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import moment from "moment";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import { formatAmount } from "../../../utility/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import ExportDataHandler from "../../../utility/ExportDataHandler";
import ImportInvoiceModal from "./ImportInvoiceModal";
import { toast } from "react-toastify";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";

export default function Invoice() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timeoutId = useRef(null);
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [importModal, setImportModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("MMMM").toLowerCase());
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const toggleImportModal = () => {
    setImportModal(!importModal);
  }
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  }
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    invoiceList: [],
    searchQuery: "",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
    isRefreshingDueDays: false,
    totals: null,
    isDeleting: false
  });

  useEffect(() => {
    if (filterDetails?.year) {
      GetInvoiceList();
    }
    if (pageStates?.companyList?.length == 0) {
      GetCompanyList();
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    filterDetails?.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    filterDetails?.due,
    pageStates?.isInitial,
    selectedMonth,
  ]);

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  const GetInvoiceList = () => {
    let options = {
      method: "GET",
    };
    const { sortByDate, months, sortBySingleDate, startDate, endDate, ...restFilterDetails } = filterDetails || {};
    let API =
      apiUrl.get_invoice +
      "?" +
      MainFilterHandler({
        ...restFilterDetails,
        siteId: pageStates?.siteId,
        searchQuery: pageStates?.searchQuery,
      }) + (selectedMonth ? `&month=${selectedMonth}` : "");
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerData: {},
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.invoice?.map((item) => ({
          ...item,
          inDate: moment(item?.invoiceDate).format("DD-MM-YYYY"),
          siteName: item?.workorder?.site?.name,
          workOrder: item?.workorder?.workOrderNumber,
          taxableAmt: formatAmount(item?.taxableAmount),
          total: formatAmount(item?.totalAmount),
          tdsAmt: formatAmount(item?.tdsAmount),
          gstAmt: formatAmount(item?.totalAmount - item?.taxableAmount || 0),
          retentionAmount: formatAmount(item?.rententionAmount || 0),
          recievedAmt: formatAmount(item?.receivedAmount || 0),
          gstAmount: formatAmount(item?.totalAmount - item?.taxableAmount),
          grossAmount: formatAmount(item?.grossAmount),
          paymentDueAmt: formatAmount(item?.paymentDue),
          DueDays: item?.dueDays,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          invoiceList: newData,
          totals: response?.data?.totals || null,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
              companyId: filterDetails?.companyId,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.invoice_detail + `/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_invoice, { state: { data: data } });
  };

  const HandleDelete = (data) => {
    setSelectedInvoice(data);
    toggleDeleteModal();
  };

  const ConfirmDelete = () => {
    if (!selectedInvoice) return;
    let options = {
      method: "GET",
    };

    let API = apiUrl.delete_invoice + `?invoiceId=${selectedInvoice?.id}`;

    setPageStates((prev) => ({ ...prev, isDeleting: true }));
    callApi(API, options)
      .then((response) => {
        setPageStates((prev) => ({ ...prev, isDeleting: false }));
        toggleDeleteModal();
        if (response?.status) {
          toast.success(response?.message);
          GetInvoiceList();
        } else {
          toast.error(response?.message || "Failed to delete invoice");
        }
      })
      .catch(() => {
        setPageStates((prev) => ({ ...prev, isDeleting: false }));
        toggleDeleteModal();
        toast.error("Something went wrong");
      });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "invoiceNumber", label: "INV NO." },
    { value: "inDate", label: "Invoice Date" },
    { value: "siteName", label: "site " },
    { value: "workOrder", label: "work Order" },
    { value: "DueDays", label: "Due Days" },
    { value: "taxableAmt", label: "Taxable Amount" },
    { value: "gstAmount", label: "GST Amount" },
    { value: "total", label: "Total Amount" },
    { value: "tdsAmt", label: "TDS Amount" },
    { value: "retentionAmount", label: "Retention Amount" },
    { value: "grossAmount", label: "Net Receivable" },
    { value: "recievedAmt", label: "Received Amount" },
    { value: "paymentDueAmt", label: "Payment Due" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    userDetails?.designation?.name === "Director" && {
      label: "delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      clickHandler: HandleDelete,
    },
  ];

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleExport = () => {
    const { startDate, endDate, sortByDate, months, sortBySingleDate, ...restFilterDetails } = filterDetails || {};
    let filterData = {
      exportDataType: "invoice",
      searchQuery: pageStates?.searchQuery,
      ...restFilterDetails,
      ...(selectedMonth && { month: selectedMonth }),
    };
    delete filterData?.currentPage;
    delete filterData?.pageSize;
    delete filterData?.count;
    delete filterData?.totalPages;
    ExportDataHandler(filterData);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
    { value: "dueDaysAsc", name: "Due date - asc" },
    { value: "dueDaysDesc", name: "Due date - desc" },
  ];

  const dueList = [
    { value: "", name: "All" },
    { value: "due", name: "Due" },
    { value: "longDue", name: "Long Due" },
  ];

  const dueHandler = (e) => {
    dispatch(
      updateFiltersStates({
        due: e.target.value,
      })
    );
  };

  const handleRefresh = () => {
    setPageStates((prev) => ({ ...prev, isRefreshingDueDays: true }));
    callApi(apiUrl.recalculate_due_days, { method: "GET" })
      .then((response) => {
        setPageStates((prev) => ({ ...prev, isRefreshingDueDays: false }));
        if (response?.status === true) {
          toast.success(response?.message || "Due days recalculated successfully");
          GetInvoiceList();
        } else {
          toast.error(response?.message || "Failed to recalculate due days");
        }
      })
      .catch(() => {
        setPageStates((prev) => ({ ...prev, isRefreshingDueDays: false }));
        toast.error("Something went wrong");
      });
  };

  return (
    <>
      <style>{`
        .invoice-kpi-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
          margin-bottom: 24px;
        }
        @media (max-width: 1200px) {
          .invoice-kpi-row {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (max-width: 900px) {
          .invoice-kpi-row {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 576px) {
          .invoice-kpi-row {
            grid-template-columns: 1fr;
          }
        }
        .invoice-kpi-card {
          border-radius: 12px;
          padding: 12px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.25s ease;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
        }
        .invoice-kpi-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
        }
        .invoice-kpi-info {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        .invoice-kpi-title {
          font-size: 13px;
          font-weight: 500;
        }
        .invoice-kpi-value {
          font-size: 20px;
          font-weight: 700;
          margin: 2px 0;
        }
        .invoice-kpi-subtext {
          font-size: 11px;
          opacity: 0.8;
        }
        .invoice-kpi-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          flex-shrink: 0;
          box-shadow: 0 4px 6px rgba(0,0,0,0.06);
        }
      `}</style>
      <div className="content">
        <MainHeading
          title={"Invoice"}
          buttonIcon={<PlusIcon />}
          buttonLink={userDetails?.type !== 2 && RoutesLink.create_invoice}
          buttonText={"Create Invoice"}
          handleYearChange={handleYearChange}
          monthChangeHandler={setSelectedMonth}
          selectedMonth={selectedMonth}
        />

        {pageStates?.totals && (
          <div className="invoice-kpi-row">
            {/* Total Amount (Gross) */}
            <div className="invoice-kpi-card" style={{ background: "#eff6ff", border: "1px solid rgba(59, 130, 246, 0.2)", color: "#1e3a8a" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#048604" }}>Total Amount (Gross)</span>
                <h4 className="invoice-kpi-value">{formatAmount(pageStates.totals.totalAmount || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#048604" }}>Total gross invoice value</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#048604" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                  <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                </svg>
              </div>
            </div>

            {/* Total Taxable Amount */}
            <div className="invoice-kpi-card" style={{ background: "#f5f3ff", border: "1px solid rgba(139, 92, 246, 0.2)", color: "#4c1d95" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#8b5cf6" }}>Total Taxable Amount</span>
                <h4 className="invoice-kpi-value">{formatAmount(pageStates.totals.totalTaxableAmount || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#7c3aed" }}>Excluding tax value</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#8b5cf6" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z" />
                  <path d="M5.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z" />
                </svg>
              </div>
            </div>

            {/* Total GST Amount */}
            <div className="invoice-kpi-card" style={{ background: "#ecfeff", border: "1px solid rgba(6, 182, 212, 0.2)", color: "#083344" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#06b6d4" }}>Total GST Amount</span>
                <h4 className="invoice-kpi-value">{formatAmount(pageStates.totals.totalGstAmount || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#0891b2" }}>GST component value</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#06b6d4" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M5.5 2A.5.5 0 0 0 5 2.5V3H4.5a.5.5 0 0 0 0 1H5v3h-.5a.5.5 0 0 0 0 1H5v.5A1.5 1.5 0 0 0 6.5 9h3A1.5 1.5 0 0 0 11 7.5V7h.5a.5.5 0 0 0 0-1H11V3h.5a.5.5 0 0 0 0-1H11v-.5A.5.5 0 0 0 10.5 2h-5zM6 3h4v4H6V3zm3.5 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                  <path d="M0 11.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm1.5 3a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z" />
                </svg>
              </div>
            </div>

            {/* Total Net Receivable */}
            <div className="invoice-kpi-card" style={{ background: "#e0e7ff", border: "1px solid rgba(99, 102, 241, 0.2)", color: "#1e1b4b" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#6366f1" }}>Total Net Receivable</span>
                <h4 className="invoice-kpi-value">{formatAmount(pageStates.totals.totalNetReceivable || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#4f46e5" }}>Taxable amount - TDS + GST</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#6366f1" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-13zM0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13z" />
                  <path d="M13.5 4a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1 0-1h10a.5.5 0 0 1 .5.5zm0 3a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1 0-1h10a.5.5 0 0 1 .5.5zm0 3a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1 0-1h10a.5.5 0 0 1 .5.5z" />
                </svg>
              </div>
            </div>

            {/* Total Received Amount */}
            <div className="invoice-kpi-card" style={{ background: "#ecfdf5", border: "1px solid rgba(16, 185, 129, 0.2)", color: "#064e3b" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#10b981" }}>Total Received Amount</span>
                <h4 className="invoice-kpi-value text-success">{formatAmount(pageStates.totals.totalReceivedAmount || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#059669" }}>Inflow cleared by client</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#10b981" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M1.5 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-13zM0 2.5A1.5 1.5 0 0 1 1.5 1h13A1.5 1.5 0 0 1 16 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-11z" />
                  <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                </svg>
              </div>
            </div>

            {/* Total TDS Amount */}
            <div className="invoice-kpi-card" style={{ background: "#fffbeb", border: "1px solid rgba(245, 158, 11, 0.2)", color: "#78350f" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#f59e0b" }}>Total TDS Amount</span>
                <h4 className="invoice-kpi-value text-warning">{formatAmount(pageStates.totals.totalTdsAmount || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#d97706" }}>Tax deducted at source</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#f59e0b" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM4.5 9a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM4 11.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z" />
                </svg>
              </div>
            </div>

            {/* Total Retention Amount */}
            <div className="invoice-kpi-card" style={{ background: "#f9fafb", border: "1px solid rgba(107, 114, 128, 0.2)", color: "#1f2937" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#6b7280" }}>Total Retention Amount</span>
                <h4 className="invoice-kpi-value" style={{ color: "#4b5563" }}>{formatAmount(pageStates.totals.totalRetentionAmount || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#4b5563" }}>Retention component held</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#6b7280" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                </svg>
              </div>
            </div>

            {/* Total Payment Due */}
            <div className="invoice-kpi-card" style={{ background: "#fef2f2", border: "1px solid rgba(239, 68, 68, 0.2)", color: "#7f1d1d" }}>
              <div className="invoice-kpi-info">
                <span className="invoice-kpi-title" style={{ color: "#ef4444" }}>Total Payment Due</span>
                <h4 className="invoice-kpi-value text-danger">{formatAmount(pageStates.totals.totalPaymentDue || 0)}</h4>
                <span className="invoice-kpi-subtext" style={{ color: "#dc2626" }}>Yet to be cleared/received</span>
              </div>
              <div className="invoice-kpi-icon" style={{ background: "#ef4444" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L7.1 4.995z" />
                </svg>
              </div>
            </div>
          </div>
        )}

        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleRefresh={(userDetails?.type === 2 || userDetails?.designation?.name === "Director") && handleRefresh}
              handleSearch={handleSearchChange}
              filterArray={sortList}
              handleData={handleSortData}
              pageStates={pageStates}
              handleExport={
                pageStates?.invoiceList?.length > 0 ? handleExport : null
              }
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              dueHandler={dueHandler}
              dueList={dueList}
              getSite={GetSiteList}
              getCompany={GetCompanyList}
              handleImport={toggleImportModal}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.invoiceList}
              ActionData={ActionData}
              currentPage={filterDetails?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={filterDetails?.totalPages}
              count={filterDetails?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={filterDetails?.pageSize}
            />
          </div>
        </div>
      </div>
      <ImportInvoiceModal
        modal={importModal}
        toggle={toggleImportModal}
      />
      <ConfirmModal
        modal={deleteModal}
        toggle={toggleDeleteModal}
        submitHandler={ConfirmDelete}
        isLoading={pageStates?.isDeleting}
      />
      {pageStates?.isRefreshingDueDays && <BgBlurLoader />}
    </>
  );
}
